module.exports = __webpack_public_path__ + "static/media/icon_walk_grey.61bac7e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Icons/icon_walk_grey.svg
// module id = 806
// module chunks = 0